import React from 'react';
// import './WhyChooseUs.css';

const features = [
  {
    icon: (
      <svg width="36" height="36" fill="none" viewBox="0 0 36 36">
        <rect width="36" height="36" rx="12" fill="#232D7E" opacity="0.08" />
        <path
          d="M18 8l8 4v5c0 5.25-3.44 10-8 11-4.56-1-8-5.75-8-11V12l8-4z"
          stroke="#232D7E"
          strokeWidth="2.5"
          fill="none"
        />
        <path
          d="M15.5 18.5l2.5 2.5 4-4"
          stroke="#FF9900"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Designed for Efficiency, Built for Security",
    desc: "Experience faster document management with Docusafe.ai, designed to boost efficiency and safeguard your data with enterprise-grade security."
  },
  {
    icon: (
      <svg width="36" height="36" fill="none" viewBox="0 0 36 36">
      <rect width="36" height="36" rx="12" fill="#FF9900" opacity="0.08" />
      <circle cx="18" cy="18" r="7" stroke="#FF9900" strokeWidth="2.5" fill="none"/>
      <path d="M18 18v-4" stroke="#FF9900" strokeWidth="2" strokeLinecap="round"/>
      <path d="M18 18h3" stroke="#FF9900" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="24" cy="24" r="2" stroke="#FF9900" strokeWidth="1.5" fill="white"/>
      <g stroke="#FF9900" strokeWidth="1">
        <line x1="24" y1="21.5" x2="24" y2="20.5"/>
        <line x1="24" y1="26.5" x2="24" y2="25.5"/>
        <line x1="21.5" y1="24" x2="20.5" y2="24"/>
        <line x1="26.5" y1="24" x2="25.5" y2="24"/>
        <line x1="22.6" y1="22.6" x2="22" y2="22"/>
        <line x1="25.4" y1="25.4" x2="26" y2="26"/>
        <line x1="22.6" y1="25.4" x2="22" y2="26"/>
        <line x1="25.4" y1="22.6" x2="26" y2="22"/>
      </g>
    </svg>
    ),
    title: "Time Saving Automation",
    desc: "Docusafe.ai automates routine tasks, saving you time and reducing human error, allowing you to focus on more important work."
  },
  {
    icon: (
      <svg width="36" height="36" fill="none" viewBox="0 0 36 36">
        <rect width="36" height="36" rx="12" fill="#232D7E" opacity="0.08" />
        <path d="M12 26V16a6 6 0 0 1 12 0v10" stroke="#232D7E" strokeWidth="2.5" fill="none"/>
        <rect x="15" y="22" width="6" height="6" rx="2" stroke="#FF9900" strokeWidth="2" fill="white"/>
        <circle cx="18" cy="25" r="1" fill="#FF9900"/>
      </svg>
    ),
    title: "Secure Client Portal",
    desc: "The platform offers a highly secure client portal, ensuring seamless document access and management with advanced encryption, safeguarding your sensitive data at all times."
  },
  {
    icon: (
      <svg width="36" height="36" fill="none" viewBox="0 0 36 36">
        <rect width="36" height="36" rx="12" fill="#FF9900" opacity="0.08" />
        <rect x="10" y="15" width="8" height="6" rx="1.5" stroke="#FF9900" strokeWidth="2" fill="white"/>
        <circle cx="24" cy="24" r="3" stroke="#FF9900" strokeWidth="2" fill="none"/>
        <line x1="26" y1="26" x2="29" y2="29" stroke="#FF9900" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    title: "Advanced Search & Categorization",
    desc: "With advanced search and categorization tools, effortlessly organize and access documents, enhancing productivity and ensuring efficient document management across your platform."
  },
  {
    icon: (
      <svg width="36" height="36" fill="none" viewBox="0 0 36 36">
        <rect width="36" height="36" rx="12" fill="#232D7E" opacity="0.08" />
        <circle cx="14" cy="22" r="2" stroke="#232D7E" strokeWidth="2" fill="white"/>
        <rect x="20" y="14" width="8" height="2" rx="1" fill="#232D7E"/>
        <rect x="10" y="18" width="8" height="2" rx="1" fill="#232D7E"/>
        <rect x="20" y="22" width="6" height="2" rx="1" fill="#232D7E"/>
        <line x1="16" y1="22" x2="28" y2="10" stroke="#FF9900" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    title: "Complete Control & Access Management",
    desc: "Take full control of document access, set permissions, and manage who can view or edit documents, ensuring security and efficiency."
  }
];

const images = [
  'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80'
];

const WhyChooseUs = () => {
  return (
    <section className="whychoose-section">
      <div className="container">
        {/* <div className="whychoose-container"> */}
        <div className="whychoose-content">
          <h2 className="whychoose-title">
            Why Choose Us?
            <span className="whychoose-underline"></span>
          </h2>
          <div className="whychoose-features">
            {features.map((f, i) => (
              <div className="whychoose-feature-card" key={i}>
                <div className='whychoose-feature-card-content'>
                  <div className="whychoose-icon">{f.icon}</div>
                  <div className="whychoose-feature-title">{f.title}</div>
                </div>
                <div>
                  <div className="whychoose-feature-desc">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <div className="whychoose-images">
          {images.map((src, i) => (
            <div className="whychoose-image-wrapper" key={i}>
              <img src={src} alt={`Why Choose Us ${i+1}`} />
            </div>
          ))}
        </div> */}
        {/* </div> */}
      </div>
    </section>
  );
}

export default WhyChooseUs;